import { HelpRequestStatuses } from '@src/utils/enums';

type HelpRequestStatusValue = (typeof HelpRequestStatuses)[keyof typeof HelpRequestStatuses];

export const HelpRequestStatusStyles: Record<HelpRequestStatusValue, string> = {
  [HelpRequestStatuses.Open]: 'open',
  [HelpRequestStatuses.InProgress]: 'in-progress',
  [HelpRequestStatuses.Completed]: 'completed',
  [HelpRequestStatuses.Closed]: 'closed',
};

const HelpRequestStatus = ({ value }: { value: string }) => {
  if (!value) return null;

  const statusStyle = HelpRequestStatusStyles[value as HelpRequestStatusValue] ?? 'default';

  return <span className={`help-request-status-tag ${statusStyle}`}>{value}</span>;
};

export default HelpRequestStatus;
